import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { GetWishlistRequest } from '../api/wishlist/getwishlist/getwishlistrequest';
import { GetWishlistResponse, GetWishlistResponseDtoImpl } from '../api/wishlist/getwishlist/getwishlistresponse';
import { GetWishlistBuilder } from '../dto/wishlist/getwishlist/getwishlistbuilder';
import { GetWishlistDtoImpl } from '../dto/wishlist/getwishlist/getwishlistdto';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class GetWishlistAPIProcessorImpl extends SixdeeCRBTAPIProcessor<GetWishlistRequest, GetWishlistResponse>
{
    private LOGGER: Logger = LogManager.getLogger(GetWishlistAPIProcessorImpl.name);
    execute(request: GetWishlistRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void {
        this.LOGGER.log("onSuccess() invoked");
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new GetWishlistResponseDtoImpl(APIFeatures.GET_WISHLIST, "Get Wishlist Success");
                let getWishlistDto =  new GetWishlistDtoImpl();
                getWishlistDto.setWishlistToneDetailsList(new GetWishlistBuilder(responseMapper.getResponseMap(),this.getContext()).buildAll());
                response.setGetWishlistDto(getWishlistDto);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new GetWishlistResponseDtoImpl(APIFeatures.GET_WISHLIST, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new GetWishlistResponseDtoImpl(APIFeatures.GET_WISHLIST, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new GetWishlistResponseDtoImpl(APIFeatures.GET_WISHLIST, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);

            this.getAPIFailure(new GetWishlistResponseDtoImpl(APIFeatures.GET_WISHLIST, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/getwishlistapiprocessor.tsx